import type { CTAButtonType, ProductItemThemeSettings } from '@providers/ThemeProvider/types';

import type { CTAButtonProps } from '@/features/filter-product-list/product-list/product-item/CallToActionButton';

export type CTAButtonPropsMapSettings = CTAButtonProps & {
  action?: 'popup' | 'quickAddToCart' | 'productPage';
  displayType?: 'textWithIcon' | 'text' | 'icon';
};

export type ProductCTAPropsMapSettings = {
  qvBtn?: CTAButtonPropsMapSettings;
  selectOptionBtn?: CTAButtonPropsMapSettings;
  goToDetailBtn?: CTAButtonPropsMapSettings;
};

export const useConnectCTAButton = (settings: ProductItemThemeSettings, place: 'img' | 'info') => {
  const productElmSettings =
    place === 'img' ? settings.productImg.elements : settings.productInfo?.elements;

  const productCTAProps: ProductCTAPropsMapSettings = {};
  if (productElmSettings) {
    // Maximum 2 btn
    ['qvBtn', 'selectOptionBtn', 'goToDetailBtn'].forEach((item) => {
      const ctasSettings = productElmSettings[item as CTAButtonType];
      if (ctasSettings) {
        productCTAProps[item as CTAButtonType] = {
          ...ctasSettings,
          iconImageSrc: ctasSettings.displayType !== 'text' ? ctasSettings.imgSrc : undefined,
          showButtonOnHover: ctasSettings.showOnHovering,
          hideOnMobile: ctasSettings.showOn === 'desktopOnly',
          position: ctasSettings.alignment,
        };
      }
    });
  }

  return {
    props: productCTAProps,
  };
};
